import {Injectable} from 'ng-metadata/core';
import {AbstractRequest} from '../abstractRequest';
import {FormBuilderEnums} from '../../../../../../../infra/formBuilder/formBuilder.service';
import { MappingTablesCache } from '../../../../../../../mappingTablesCache/mappingTablesCache.service';
import { ConfigurationUtil } from '../../../../../../../nddUtils/configurationUtil.service';


@Injectable()
export class AlmaDigitization extends AbstractRequest {
    constructor(
        private mappingTablesCache : MappingTablesCache,
        private configurationUtil:ConfigurationUtil
    ){
        super();
        this.formFields = [
            {
                key: 'partial',
                name: 'partial',
                label: '',
                value: '',
                path: 'drop-downs/isPartial',
                mandatory: false,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.CHECK_BOX,
                events: {
                    onChange: this.onChange.bind(this),
                    params: []
                },
                populator:  {
                    func: this.itemsArrayPopulator.bind(this),
                    params:     {
                       byKey: 'field-name',
                       byValue:'field-values'
                    }
                }

            },
             {
                key: 'chapterArticleTitle',
                name: 'chapterArticleTitle',
                label: 'almaDigitization.chapterArticleTitle',
                mandatory: false,
                value: '',
                 valuePath: 'chapterArticleTitle',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {key : 'partial', value: 'Yes' }


            },
             {
                key: 'chapterArticleAuthor',
                name: 'chapterArticleAuthor',
                label: 'almaDigitization.chapterArticleAuthor',
                mandatory: false,
                value: '',
                 valuePath: 'chapterArticleAuthor',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {key : 'partial', value: 'Yes' }
            },
             {
                key: 'startPage',
                name: 'startPage',
                label: 'almaDigitization.startPage',
                mandatory: false,
                value: '',
                 valuePath: 'startPage',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {key : 'partial', value: 'Yes' },
                inputType:'number',
                validPattern: '[1-9]+\\d*'
            },
              {
                key: 'endPage',
                name: 'endPage',
                label: 'almaDigitization.endPage',
                mandatory: false,
                value: '',
                  valuePath: 'endPage',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT,
                dependOn: {key : 'partial', value: 'Yes' },
                inputType:'number',
               validPattern: '[1-9]+\\d*'
            },
            {
                key: 'fullChapter',
                name: 'fullChapter',
                label: '',
                value: '',
                existingPath: 'dummyPath',
                mandatory: false,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.CHECK_BOX,
                dependOn: {key : 'partial', value: 'Yes' },
                options:[
                    {
                        label: 'almaDigitization.fullChapter',
                        value:'N'
                    }
                ]

            },
            {
                key: 'comment',
                name: 'comment',
                label: 'almaDigitization.comment',
                mandatory: false,
                value: '',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.TEXT
            },
            {
                key: 'notNeededAfter',
                name: 'notNeededAfter',
                label: 'almaDigitization.notNeededAfter',
                valuePath: 'pickupDate',
                mandatory: false,
                value: '',
                existingPath: 'dummyPath',
                minDate: 'now',
                fieldType: FormBuilderEnums.FIELD_TYPE.DATE,
                uiType: FormBuilderEnums.UI_TYPE.DATE,
                populator:  {
                    params:     {
                        allow       : FormBuilderEnums.FUTURE_DATES
                    }
                }
            },
            {
                key: 'generalUseLabel',
                name: 'generalUseLabel',
                label: 'almaDigitization.generalUseLabel',
                mandatory: false,
                value: '',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                minDate: 'now',
                uiType: FormBuilderEnums.UI_TYPE.INTERACTABLE_LABEL
            },
            {
                key: 'calculateQueueButton',
                name: 'calculateQueueButton',
                label: 'request.calcPlaceInQueue',
                mandatory: false,
                value: '',
                existingPath: 'dummyPath',
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.BUTTON_AND_TEXT,
                options: {
                    ariaLabel: 'nui.aria.request.calcPlaceInQueue',
                    textLabel: 'request.placeInQueue',
                    numInQueue: undefined
                }
            },
            {
                key: 'genericCheckBox',
                name: 'genericCheckBox',
                label: '',
                value: '',
                existingPath: 'dummyPath',
                mandatory: false,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.CHECK_BOX,
                populator:  {
                    deleteFromFormDataIfHidden: 'true'
                },
                options:[
                    {
                        label: 'almaDigitization.genericCheckBox',
                        value:'N'
                    }
                ]
            },
            {
                key: 'copyrightDeclaration',
                name: 'copyrightDeclaration',
                label: '',
                headline: 'almaDigitization.copyright.sub_title',
                value: '',
                existingPath: 'dummyPath',
                mandatory: true,
                fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
                uiType: FormBuilderEnums.UI_TYPE.CHECK_BOX,
                populator:  {
                    deleteFromFormDataIfHidden: 'true'
                },
                options:[
                    {
                        label:'almaDigitization.copyright.message',
                        value:'N'
                    }
                ]
            }
        ];
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/request/requestTypes/alma/almaDigitization.ts